import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=347db74a&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=347db74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347db74a",
  null
  
)

export default component.exports